import { render, staticRenderFns } from "./JsonTagListEditor.vue?vue&type=template&id=74edbc32&scoped=true&"
import script from "./JsonTagListEditor.vue?vue&type=script&lang=js&"
export * from "./JsonTagListEditor.vue?vue&type=script&lang=js&"
import style0 from "./JsonTagListEditor.vue?vue&type=style&index=0&id=74edbc32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74edbc32",
  null
  
)

export default component.exports